export default __webpack_public_path__ + "static/media/portfolio-8.0d2f076b.jpg";